<template>
	<div>
		<div class="columns is-multiline">
			<div class="column is-3">
				<b-field label="Type">
					<b-select placeholder="Clock type" v-model="clock.type" expanded>
						<option value="A">Analog</option>
						<option value="D">Digital</option>
					</b-select>
				</b-field>
			</div>

			<div v-if="clock.type == 'D'" class="column is-3">
				<b-field label="Format">
					<b-select placeholder="Clock format" v-model="clock.format" expanded>
						<option :value="12">12-hour</option>
						<option :value="24">24-hour</option>
					</b-select>
				</b-field>
			</div>

			<div v-if="clock.type == 'A'" class="column is-3">
				<b-field label="Clock Template">
					<b-autocomplete
            :data="clock_templates"
            field="title"
            open-on-focus
            @select="option => clock.analog.template = option.id">
              <template slot-scope="props">
                  <div class="media">
                      <div class="media-left">
                        <img width="64" :src="props.option.img">
                      </div>
                      <div class="media-content">
                        {{ props.option.title }}
                      </div>
                  </div>
              </template>
          </b-autocomplete>
				</b-field>
			</div>

			<div class="column is-6">
				<b-field label="Hour : Min : Sec" grouped>
					<b-field expanded>
						<b-select placeholder="Hour" v-model="clock.hour" expanded>
							<option v-for="hour in listHours" :key="`HOUR_${hour}`" :value="hour">{{hour}}</option>
						</b-select>
						<b-switch v-model="clock.is_hour_hidden" size="is-small" :rounded="false">Hide Hours</b-switch>
					</b-field>

					<b-field expanded>
						<b-select placeholder="Minute" v-model="clock.minute" expanded>
							<option v-for="minute in listMinutesAndSeconds" :key="`MINUTE_${minute}`" :value="minute">{{minute}}</option>
						</b-select>
						<b-switch v-model="clock.is_minute_hidden" size="is-small" :rounded="false">Hide Minutes</b-switch>
					</b-field>

					<b-field expanded>
						<b-select placeholder="Second" v-model="clock.second" expanded>
							<option v-for="second in listMinutesAndSeconds" :key="`SECOND_${second}`" :value="second">{{second}}</option>
						</b-select>
						<b-switch v-model="clock.is_second_hidden" size="is-small" :rounded="false">Hide Seconds</b-switch>
					</b-field>
					
				</b-field>
			</div>
		</div>
		<style-editor show_width show_height show_bg_color show_border_color show_font_color  v-if="clock.type == 'D'" v-model="clock.digital.styles" />
		<style-editor show_width show_height show_bg_color show_border_color show_font_color v-if="clock.type == 'A'" v-model="clock.analog.styles" />

		<show-clock :clock="clock" />
</div>
</template>
<script>
import StyleEditor from '@/components/Common/StyleEditor/StyleEditor.vue'
import ShowClock from '@/components/Question/Clock/ShowClock'
import {clock_templates, defaultClockValue} from './utils'

export default {
	name : 'set-clock',
	components : {
		StyleEditor,
		ShowClock
	},
	props : {
		value : {
			type : Object
		}
	},
	data(){
		return {
			clock : this.value ? this.value : defaultClockValue(),
			clock_templates
		}
	},
	watch : {
		clock : {
			handler : function(new_val){
				this.$emit('input', new_val)
			}, 
			deep : true
		},
		value : {
			handler : function(new_val){
				this.clock = new_val
			}, 
			deep : true
		}
	},
	computed : {
		listHours(){
			let min = 0, max = 23
			let hours = []
			for(let current_hour = min; current_hour <= max; current_hour++){
				hours.push(current_hour)
			}
			return hours
		}, 
		listMinutesAndSeconds(){
			let min_sec = 0, max = 60
			let vals = []
			for(let current = min_sec; current <= max; current++){
				vals.push(current)
			}
			return vals
		}
	}
}
</script>